import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _merge from "lodash/merge";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import Utility from "../../Utility/Utility";
import ScriptLoader from "../../Utility/ScriptLoader";
import ConditionalWrapper from "../../Utility/ConditionalWrapper";
import { ScrollTransform } from "../../ScrollTransform/ScrollTransform";
import { jsx as _jsx } from "react/jsx-runtime";
export var aspectRatios = ['horizontal', 'square', 'vertical'];
export var BrightcoveVideo = function BrightcoveVideo(_ref) {
  var accountId = _ref.accountId,
      _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? 'horizontal' : _ref$aspectRatio,
      playerId = _ref.playerId,
      videoId = _ref.videoId,
      _ref$autoplay = _ref.autoplay,
      autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
      _ref$autoPlayOnScroll = _ref.autoPlayOnScroll,
      autoPlayOnScroll = _ref$autoPlayOnScroll === void 0 ? false : _ref$autoPlayOnScroll,
      _ref$percentScrollToP = _ref.percentScrollToPlay,
      percentScrollToPlay = _ref$percentScrollToP === void 0 ? 0.05 : _ref$percentScrollToP,
      _ref$percentScrollToS = _ref.percentScrollToStop,
      percentScrollToStop = _ref$percentScrollToS === void 0 ? 0.85 : _ref$percentScrollToS,
      _ref$controls = _ref.controls,
      controls = _ref$controls === void 0 ? true : _ref$controls,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? false : _ref$loop,
      _ref$muted = _ref.muted,
      muted = _ref$muted === void 0 ? false : _ref$muted,
      _ref$onPlay = _ref.onPlay,
      onPlay = _ref$onPlay === void 0 ? function () {} : _ref$onPlay,
      _ref$onPause = _ref.onPause,
      onPause = _ref$onPause === void 0 ? function () {} : _ref$onPause,
      _ref$onDuration = _ref.onDuration,
      onDuration = _ref$onDuration === void 0 ? function () {} : _ref$onDuration,
      _ref$onProgress = _ref.onProgress,
      onProgress = _ref$onProgress === void 0 ? function () {} : _ref$onProgress,
      _ref$onFinish = _ref.onFinish,
      onFinish = _ref$onFinish === void 0 ? function () {} : _ref$onFinish,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? function () {} : _ref$onError,
      _ref$playOnVideoUpdat = _ref.playOnVideoUpdate,
      playOnVideoUpdate = _ref$playOnVideoUpdat === void 0 ? false : _ref$playOnVideoUpdat,
      _ref$playTitle = _ref.playTitle,
      playTitle = _ref$playTitle === void 0 ? 'Play Video' : _ref$playTitle,
      _ref$pauseTitle = _ref.pauseTitle,
      pauseTitle = _ref$pauseTitle === void 0 ? 'Pause Video' : _ref$pauseTitle;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPlaying = _useState2[0],
      setIsPlaying = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFinished = _useState4[0],
      setIsFinished = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      progress = _useState6[0],
      setProgress = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      duration = _useState8[0],
      setDuration = _useState8[1];

  var getCurrentTimeMs = function getCurrentTimeMs(bcPlayer) {
    return Math.round(bcPlayer.currentTime() * 1000);
  };

  var getDurationMs = function getDurationMs(bcPlayer) {
    return Math.round(bcPlayer.duration() * 1000);
  };

  var bc = useRef({});
  var player = useRef();
  var playerInstanceId = useRef(Utility.generateUID());
  var isAutoPlaying = useRef(false);
  var volumeChanged = useRef(false);
  var playerOnPause = useRef(false);
  var forceRecalculate = useRef(function () {});
  var videoElement = useRef(null);

  var getOtherPlayers = function getOtherPlayers() {
    if (typeof window === 'undefined' || !player.current) {
      return [];
    }

    var currentPlayerId = player.current.id();
    var allPlayers = window.videojs.getPlayers();
    return Object.values(allPlayers).filter(function (bcPlayer) {
      return bcPlayer && bcPlayer.id() !== currentPlayerId;
    });
  };

  var pauseOtherPlayers = function pauseOtherPlayers() {
    getOtherPlayers().forEach(function (bcPlayer) {
      if (bcPlayer.readyState() > 2) {
        bcPlayer.pause();
      }
    });
  };

  var isOtherPlayersFullscreen = function isOtherPlayersFullscreen() {
    return getOtherPlayers().some(function (player) {
      return player.isFullscreen();
    });
  };

  var isCurrentPlayerFullscreen = function isCurrentPlayerFullscreen() {
    return player.current && player.current.isFullscreen();
  };

  var updatePlayButtons = function updatePlayButtons(title) {
    if (player.current) {
      // Big play button 'title' attribute and <span> text.
      var bigPlayButton = player.current.bigPlayButton.el();

      if (bigPlayButton) {
        bigPlayButton.title = title;

        if (bigPlayButton.firstChild && bigPlayButton.firstChild instanceof HTMLElement) {
          bigPlayButton.firstChild.innerHTML = title;
        }
      } // Control bar play button 'title' attribute and <span> text.


      var controlBar = player.current.controlBar.el();

      if (controlBar && controlBar.firstChild && controlBar.firstChild instanceof HTMLElement) {
        controlBar.firstChild.title = title;

        if (controlBar.firstChild.firstChild && controlBar.firstChild.firstChild instanceof HTMLElement) {
          controlBar.firstChild.firstChild.innerHTML = title;
        }
      }
    }
  };

  var unMuteVideo = function unMuteVideo() {
    // Unmute if:
    // 1. User didn't touch volume.
    // 2. Was muted
    // 3. Is autoplaying now after scroll.
    if (isAutoPlaying && player.current && player.current.muted() && !volumeChanged) {
      player.current.muted(false);
      player.current.volume(0.7);
    }
  };

  var onClick = function onClick() {
    // On click on video area or play/pause toggle.
    playerOnPause.current = !playerOnPause.current; // To unmute after video was resumed.

    if (player.current && !player.current.paused()) {
      unMuteVideo();
    }
  };

  var initPlayer = function initPlayer() {
    // Suggested for log warnings:
    // https://support.brightcove.com/en/video-cloud/docs/known-issues-studio-and-brightcove-player#player
    // From support email from Brightcove:
    // You could disable debug console output by redefining the player's functions and make
    // them an empty function by adding some JavaScript to your page as shown below.' +
    // ----------------------------------------
    // videojs.log.debug = function(){}
    // videojs.log.warn = function(){}
    // videojs.log.info = function(){}
    // videojs.log.error = function(){}
    // ----------------------------------------
    var videojs = window.videojs;

    videojs.log.warn = function () {// Empty videojs log warnings.
    }; // Setup the player.


    var videoPlayer = videojs(videoElement.current);

    var onPlayerPlay = function onPlayerPlay() {
      updatePlayButtons(pauseTitle);
      pauseOtherPlayers();
      setIsPlaying(true);

      if (player.current) {
        setProgress(getCurrentTimeMs(player.current));
      }

      setIsFinished(false);
    };

    var onPlayerPause = function onPlayerPause() {
      updatePlayButtons(playTitle);
      setIsPlaying(false);

      if (player.current) {
        setProgress(getCurrentTimeMs(player.current));
      }
    };

    var onPlayerFullscreenChange = function onPlayerFullscreenChange() {
      unMuteVideo();
    };

    var onPlayerSeeked = function onPlayerSeeked() {
      if (player.current) {
        setProgress(getCurrentTimeMs(player.current));
      }

      setIsFinished(false);
    };

    var onPlayerDurationChange = function onPlayerDurationChange() {
      if (player.current) {
        setDuration(getDurationMs(player.current));
      }
    };

    var onPlayerEnded = function onPlayerEnded() {
      // Calling syncronously here inteferes with player and causes errors to be thrown.
      setTimeout(function () {
        setIsFinished(true);
      }, 0);
    };

    var onPlayerError = function onPlayerError() {
      if (player.current) {
        onError(player.current.error());
      }
    };

    var onPlayerProgressSliderMoved = function onPlayerProgressSliderMoved() {
      // We have to use this event handler instead of
      // onSeeked because onSeeked is fired not only
      // on user ineracts with progress bar but also
      // on restarting video once it's ended - if loop is on.
      // So if user didn't interact with video unmuting on
      // restarting the video will cause warning and video stops.
      unMuteVideo();
    };

    var onPlayerVolumeChanged = function onPlayerVolumeChanged() {
      // On both changing volume with volume bar
      // and with clicking on mute/unmute button.
      volumeChanged.current = true;
    };

    videoPlayer.ready(function () {
      var _videoPlayer$controlB, _videoPlayer$controlB2, _videoPlayer$controlB3, _videoPlayer$controlB4, _videoPlayer$controlB5, _videoPlayer$controlB6, _videoPlayer$controlB7, _videoPlayer$controlB8, _videoPlayer$controlB9, _videoPlayer$controlB10, _videoPlayer$controlB11, _videoPlayer$controlB12, _videoPlayer$controlB13, _videoPlayer$controlB14, _videoPlayer$controlB15, _videoPlayer$controlB16, _videoPlayer$controlB17, _videoPlayer$controlB18, _videoPlayer$controlB19, _videoPlayer$controlB20, _videoPlayer$controlB21;

      videoPlayer.on('play', onPlayerPlay);
      videoPlayer.on('pause', onPlayerPause);
      videoPlayer.on('fullscreenchange', onPlayerFullscreenChange);
      videoPlayer.on('seeked', onPlayerSeeked);
      videoPlayer.on('durationchange', onPlayerDurationChange);
      videoPlayer.on('ended', onPlayerEnded);
      videoPlayer.on('error', onPlayerError); // On mouseup, touchend on progress bar:
      // https://docs.brightcove.com/brightcove-player/current-release/SeekBar.html#event:sliderinactive

      (_videoPlayer$controlB = videoPlayer.controlBar) === null || _videoPlayer$controlB === void 0 ? void 0 : (_videoPlayer$controlB2 = _videoPlayer$controlB.progressControl) === null || _videoPlayer$controlB2 === void 0 ? void 0 : (_videoPlayer$controlB3 = _videoPlayer$controlB2.seekBar) === null || _videoPlayer$controlB3 === void 0 ? void 0 : _videoPlayer$controlB3.on('sliderinactive', onPlayerProgressSliderMoved); // On mouseup, touchend on volume bar:
      // https://docs.brightcove.com/brightcove-player/current-release/VolumeBar.html

      (_videoPlayer$controlB4 = videoPlayer.controlBar) === null || _videoPlayer$controlB4 === void 0 ? void 0 : (_videoPlayer$controlB5 = _videoPlayer$controlB4.volumeMenuButton) === null || _videoPlayer$controlB5 === void 0 ? void 0 : (_videoPlayer$controlB6 = _videoPlayer$controlB5.volumeBar) === null || _videoPlayer$controlB6 === void 0 ? void 0 : _videoPlayer$controlB6.on('sliderinactive', onPlayerVolumeChanged); // Mute/unmute button click.

      (_videoPlayer$controlB7 = videoPlayer.controlBar) === null || _videoPlayer$controlB7 === void 0 ? void 0 : (_videoPlayer$controlB8 = _videoPlayer$controlB7.volumeMenuButton) === null || _videoPlayer$controlB8 === void 0 ? void 0 : _videoPlayer$controlB8.on('click', onPlayerVolumeChanged); // PlayToggle extends ClickableComponent
      // https://docs.brightcove.com/brightcove-player/current-release/clickable-component.js.html

      (_videoPlayer$controlB9 = videoPlayer.controlBar) === null || _videoPlayer$controlB9 === void 0 ? void 0 : (_videoPlayer$controlB10 = _videoPlayer$controlB9.playToggle) === null || _videoPlayer$controlB10 === void 0 ? void 0 : _videoPlayer$controlB10.on('click', onClick);
      videoPlayer.contextmenu({
        disabled: true
      }); // Initialize aria values

      (_videoPlayer$controlB11 = videoPlayer.controlBar) === null || _videoPlayer$controlB11 === void 0 ? void 0 : (_videoPlayer$controlB12 = _videoPlayer$controlB11.progressControl) === null || _videoPlayer$controlB12 === void 0 ? void 0 : (_videoPlayer$controlB13 = _videoPlayer$controlB12.seekBar) === null || _videoPlayer$controlB13 === void 0 ? void 0 : (_videoPlayer$controlB14 = _videoPlayer$controlB13.bar) === null || _videoPlayer$controlB14 === void 0 ? void 0 : _videoPlayer$controlB14.setAttribute('aria-valuenow', '0.0');
      (_videoPlayer$controlB15 = videoPlayer.controlBar) === null || _videoPlayer$controlB15 === void 0 ? void 0 : (_videoPlayer$controlB16 = _videoPlayer$controlB15.progressControl) === null || _videoPlayer$controlB16 === void 0 ? void 0 : (_videoPlayer$controlB17 = _videoPlayer$controlB16.seekBar) === null || _videoPlayer$controlB17 === void 0 ? void 0 : _videoPlayer$controlB17.setAttribute('aria-valuenow', '0.0');
      (_videoPlayer$controlB18 = videoPlayer.controlBar) === null || _videoPlayer$controlB18 === void 0 ? void 0 : (_videoPlayer$controlB19 = _videoPlayer$controlB18.progressControl) === null || _videoPlayer$controlB19 === void 0 ? void 0 : (_videoPlayer$controlB20 = _videoPlayer$controlB19.seekBar) === null || _videoPlayer$controlB20 === void 0 ? void 0 : (_videoPlayer$controlB21 = _videoPlayer$controlB20.tooltipProgressBar) === null || _videoPlayer$controlB21 === void 0 ? void 0 : _videoPlayer$controlB21.setAttribute('aria-valuenow', '0.0');
      videoPlayer.setAttribute('aria-label', playTitle);
      updatePlayButtons(playTitle);
      forceRecalculate.current();
    });
    player.current = videoPlayer; // Merge this back into window.bc

    window.bc = _merge(bc.current, window.bc);
  };

  var onScrollToVideo = function onScrollToVideo(percentValue, percentScroll) {
    // Do not do anything if user has clicked pause video.
    if (playerOnPause.current || !player.current) {
      return;
    }

    if (!isPlaying && percentScroll >= percentScrollToPlay && percentScroll <= percentScrollToStop) {
      // Special case: on switch to full screen
      // neighbour video should not start autoplaying.
      if (isOtherPlayersFullscreen()) {
        return;
      } // Play video and pause other players.


      player.current.muted(true);
      player.current.play();
      isAutoPlaying.current = true;
    } else if (isPlaying && (percentScroll < percentScrollToPlay || percentScroll > percentScrollToStop)) {
      // Special case: on switch to full screen
      // no need to pause().
      if (isCurrentPlayerFullscreen()) {
        return;
      }

      player.current.pause();
      isAutoPlaying.current = false;
      volumeChanged.current = false;
    }
  };

  useEffect(function () {
    isAutoPlaying.current = false;
    volumeChanged.current = false;
    playerOnPause.current = false;

    if (!autoPlayOnScroll) {
      forceRecalculate.current = function () {};
    }

    setIsPlaying(false);
    setIsFinished(false);
    setProgress(0);
  }, [autoPlayOnScroll]);
  useEffect(function () {
    // If there is no window, do not try to initialize the player.
    if (typeof window === 'undefined') {
      return;
    }

    var scriptURL = "//players.brightcove.net/".concat(accountId, "/").concat(playerId, "_default/index.min.js"); // If there are errors loading the player, log it and do not try to initialize the player.

    var error = ScriptLoader.isError(scriptURL);

    if (error) {
      onError(error);
      return;
    } // If the script failed to load, trigger the onError callback and return.


    var onScriptLoad = function onScriptLoad(error) {
      if (error) {
        onError(error);
        return;
      }

      initPlayer();
    }; // Make a copy of anything existing in window.bc
    // so we can merge it back in after Brightcove initializes.


    bc.current = window.bc; // If the script is already loaded, initialize the video now.

    if (ScriptLoader.isLoaded(scriptURL)) {
      // If already loaded, the function gets merged into an object with this.bc
      window.bc["".concat(playerId, "_default")](videoElement.current);
      initPlayer();
    } else {
      // Load the script and register and callback for when it succeeds or fails.
      ScriptLoader.load(scriptURL, onScriptLoad);
    }

    return function () {
      if (player.current) {
        player.current.dispose();
        player.current = undefined;
      }
    }; // Different useEffect hooks will handle when deps change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoPlayOnScroll, accountId, playerId]);
  useEffect(function () {
    onDuration(duration);
  }, [onDuration, duration]);
  useEffect(function () {
    onProgress(progress);
  }, [onProgress, progress]);
  useEffect(function () {
    if (isPlaying) {
      onPlay();
    } else {
      onPause();
    }
  }, [onPlay, onPause, isPlaying]);
  useEffect(function () {
    if (isFinished) {
      onFinish();
    }
  }, [onFinish, isFinished]);
  useEffect(function () {
    if (player.current && player.current.catalog && player.current.catalog.getVideo) {
      player.current.catalog.getVideo(videoId, function (error, video) {
        if (!player.current) {
          return;
        }

        if (error) {
          if (typeof player.current.catalog.error !== 'undefined') {
            var specificError = player.current.catalog.error.data[0];

            if (typeof specificError !== 'undefined' && specificError.error_code === 'VIDEO_NOT_FOUND') {
              // Build custom error object Reference https://support.brightcove.com/display-error-messages-plugin
              player.current.errors({
                errors: {
                  VIDEO_CLOUD_ERR_VIDEO_NOT_FOUND: {
                    headline: 'The Video Cloud video was not found.',
                    type: 'VIDEO_CLOUD_ERR_VIDEO_NOT_FOUND',
                    message: "The video id can't be found within the Brightcove media library. Please enter a valid id.",
                    dismiss: false
                  }
                }
              }); // Apply error messaging.

              player.current.error({
                code: 'VIDEO_CLOUD_ERR_VIDEO_NOT_FOUND'
              });
            }
          }
        }

        player.current.catalog.load(video);

        if (autoPlayOnScroll) {
          isAutoPlaying.current = false;
          volumeChanged.current = false;
          playerOnPause.current = false;
          setIsPlaying(false);
          setIsFinished(false);
          setProgress(0);
          forceRecalculate.current();
        } else if (!autoPlayOnScroll && playOnVideoUpdate) {
          // If current element is visible.
          if (player.current.contentEl().offsetParent !== null) {
            player.current.play();
          }
        }
      });
    } // Different useEffect hooks handles when autoPlayOnScroll changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [videoId, playOnVideoUpdate]);
  var videoProps = !autoPlayOnScroll ? {
    autoPlay: autoplay,
    controls: controls,
    loop: loop,
    muted: muted
  } : {
    controls: true,
    loop: true,
    playsInline: true
  };
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: autoPlayOnScroll,
    wrapper: function wrapper(_children) {
      return /*#__PURE__*/_jsx(ScrollTransform, {
        onChange: onScrollToVideo,
        startScrollPercent: 0,
        endScrollPercent: 1,
        transforms: [],
        disableCalculateOnMount: true,
        children: function children(forceScrollRecalculate) {
          forceRecalculate.current = forceScrollRecalculate;
          return _children;
        }
      });
    },
    children: /*#__PURE__*/_jsx("div", {
      className: classnames(!controls ? 'hide-controls' : undefined, aspectRatio),
      "data-e2e-name": "brightcove_video",
      children: /*#__PURE__*/_jsx("video", _objectSpread({
        id: "".concat(playerInstanceId.current, "-").concat(accountId, "-").concat(playerId, "-").concat(videoId),
        ref: videoElement,
        onClick: onClick,
        className: "video-js",
        "data-embed": "default",
        "data-video-id": videoId,
        "data-account": accountId,
        "data-player": playerId,
        "data-application-id": true // following 'autoplay' can not expected to always work on web
        // see: https://docs.brightcove.com/en/player/brightcove-player/guides/in-page-embed-player-implementation.html

      }, videoProps))
    })
  });
};